

























































































import { Vue, Component } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import {
  ResetUserCustodianRequest,
  BankCustodian,
} from "@/admin/types";
import { custodianDisplayName } from "@/shared/custodianSettingsHelper";
import * as Routes from "@/admin/route-names";
import { useUtilityStore } from "@/admin/store/utility";

function emptyRequest (): ResetUserCustodianRequest {
  return {
    emailAddress: "",
    oldCustodian: BankCustodian.None,
    newCustodian: BankCustodian.None,
  };
}

@Component({
  components: {}
})
export default class ResetUserCustodian extends Vue {
  $validator: Validator;

  model = emptyRequest();

  utilityStore = useUtilityStore();

  get bankCustodianSelectOptions () {
    return Object.keys(BankCustodian)
      .filter(k => BankCustodian[k] !== BankCustodian.None)
      .map(k => ({ value: BankCustodian[k], text: custodianDisplayName(BankCustodian[k]) }));
  }

  onSubmit () {
    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return false;
        }

        return this.utilityStore.resetUserCustodian(this.model);
      })
      .then(succeeded => {
        if (succeeded) { this.$router.push({ name: this.utilitiesRoute }); }
      });
  }

  get utilitiesRoute () {
    return Routes.Utility;
  }

  get noneBankCustodian () {
    return BankCustodian.None;
  }
}
